import { Component, OnInit } from '@angular/core';
import { environment } from "./../../../../../environments/environment";
import { NotificationService } from "src/app/core/services/notification.service";
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperService } from 'src/app/core/helper/helper.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  getImagePath: any = environment.image_path;
  access_token!: any;
  userDetails: any = [];
  constructor(private helper: HelperService, private router: Router, private notificationService: NotificationService, private authService: AuthenticationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.access_token = localStorage.getItem('customer_access_token')
    if (this.access_token) {
      this.GetUserData();
    }
  }

  getRoute() {
    const accessToken = localStorage.getItem('customer_access_token');
    if(accessToken){
      this.router.navigate(['/customer/quotation-proposal'])
    } else {
      this.router.navigate([''])
    }
  }

  GetUserData() {
    this.authService.GetProfileData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.userDetails = resJSON.data;
      } else {
        this.notificationService.showError(`${resJSON.message}`, '');
      }
    });
  }

  isStepperFormsRoute(): boolean {
    const accessToken = localStorage.getItem('customer_access_token');
    return this.router.url.includes('quotation') && accessToken !== null;
  }

  HandleLogout() {
    this.helper.Logout();
    // this.notificationService.showSuccess(`You have been successfully logged out!`, "");
    // API Call Goes Here
    // this.authService.HandleLogout().subscribe((resJSON: any) => {
    //   if (resJSON.code == 200) {
    //     this.router.navigate(['/accounts/login']);
    //     this.notificationService.showSuccess(`${resJSON.message}`, '');
    //   } else {
    //     this.notificationService.showError(`${resJSON.message}`, '');
    //   }
    // });
  }

}
